import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { twMerge } from 'tailwind-merge';
import { budgetLabel, slotsLabel } from '../../utils/event';
import { formatDate } from '../../utils/format';
import { spring } from '../../utils/motion';
import type { Fit } from '../../utils/fit';
import type { MusicEvent } from '../../types/marketplace';
interface EventListRowProps {
  event: MusicEvent;
  fit: Fit;
  saved: boolean;
  active?: boolean;
  onOpen: () => void;
  onToggleSave: () => void;
}
export function EventListRow({
  event,
  fit,
  saved,
  active,
  onOpen,
  onToggleSave
}: EventListRowProps) {
  return <li className="relative overflow-hidden rounded-md" data-id="element-575" data-mp="38hacn01kk1in">
      <div className="absolute inset-0 flex items-center justify-end rounded-md bg-tint pr-6 text-brand-strong" aria-hidden="true" data-id="element-576" data-mp="3dd96v49kwdqz">
        <StarIcon className="h-5 w-5" data-id="element-577" data-mp="1wyps4lgdqftx" />
        <span className="ml-2 text-sm font-bold" data-id="element-578" data-mp="21yvoug1iasiv">{saved ? 'Unsave' : 'Save'}</span>
      </div>
      <motion.div drag="x" dragConstraints={{
      left: 0,
      right: 0
    }} dragElastic={{
      left: 0.45,
      right: 0
    }} onDragEnd={(_, info) => {
      if (info.offset.x < -80) onToggleSave();
    }} className={twMerge('relative flex items-center gap-3 rounded-md bg-bg px-2 py-2.5 transition-colors duration-150', active ? 'bg-surface-2' : 'hover:bg-surface-2/60')} data-id="element-579" data-mp="4ydz2983u9de">
        <button type="button" onClick={onOpen} className="flex min-w-0 flex-1 items-center gap-3 rounded-sm text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-580" data-mp="nw8fv9fh5p6c">
          <img src={event.photos[0]} alt="" draggable={false} className="h-[72px] w-[72px] shrink-0 rounded-sm object-cover" data-id="element-581" data-mp="wrxumzmf3lar" />
          <span className="min-w-0 flex-1" data-id="element-582" data-mp="16nrgxapxut5q">
            <span className="flex items-center gap-2" data-id="element-583" data-mp="16oj2rttqhcit">
              <span className="truncate font-bold" data-id="element-584" data-mp="11p6hhdiigdic">{event.name}</span>
              {event.featured && <span className="shrink-0 rounded-full bg-tint px-2 text-[11px] font-bold leading-5 text-brand-strong" data-id="element-585" data-mp="3vgwgo73h2ktp">Featured</span>}
            </span>
            <span className="block truncate text-sm text-ink-2" data-id="element-586" data-mp="3dwt19i8obl5">
              {formatDate(event.date)} · {event.city.split(',')[0]} · {event.distanceKm} km
            </span>
            <span className="mt-0.5 flex items-center gap-2 text-sm" data-id="element-587" data-mp="d36liqgzvw9s">
              <span className="tabular font-bold" data-id="element-588" data-mp="i1zzsl43vrb0">{budgetLabel(event)}</span>
              <span className="text-ink-3" data-id="element-589" data-mp="i443p3208qba">·</span>
              <span className="truncate text-ink-3" data-id="element-590" data-mp="n0b9mvuei1t8">{slotsLabel(event)}</span>
            </span>
          </span>
          <span className="tabular hidden shrink-0 rounded-full bg-surface-2 px-2.5 py-1 text-[13px] font-bold sm:inline" data-id="element-591" data-mp="r3zkpoi8rfj8">{fit.score}%</span>
        </button>
        <motion.button type="button" onClick={onToggleSave} aria-label={saved ? `Unsave ${event.name}` : `Save ${event.name}`} aria-pressed={saved} whileTap={{
        scale: 0.8
      }} transition={spring.snappy} className="grid h-11 w-11 shrink-0 place-items-center rounded-full text-ink-3 transition-colors duration-150 hover:bg-surface-2 hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-592" data-mp="2su2pzjxpk76j">
          <motion.span key={String(saved)} initial={{
          scale: saved ? 0.5 : 1
        }} animate={{
          scale: 1
        }} transition={spring.bouncy} data-id="element-593" data-mp="2bkqjpfeymadv">
            <StarIcon className={twMerge('h-5 w-5', saved && 'fill-current text-brand-strong')} data-id="element-594" data-mp="397fuoern3xbv" />
          </motion.span>
        </motion.button>
      </motion.div>
    </li>;
}